import { apiClient } from "../apiClient";
export const PHAN_PHOI_DE_THI_ENDPOINT = "phan-phoi-de-thi";
export const phanPhoiDeThiApi = {
  SelectAll: () => apiClient.get(`${PHAN_PHOI_DE_THI_ENDPOINT}`),
  SelectDeThiDaPhanPhoi: () => apiClient.get(`${PHAN_PHOI_DE_THI_ENDPOINT}/de-thi-da-phan-phoi`),
  PhanPhoi: (payload: any) =>
    apiClient.post(`${PHAN_PHOI_DE_THI_ENDPOINT}/phan-phoi`, payload),
  ThuHoi: (payload: any) =>
    apiClient.post(`${PHAN_PHOI_DE_THI_ENDPOINT}/thu-hoi`, payload),
  SelectHistory: (payload: any) =>
    apiClient.post(`${PHAN_PHOI_DE_THI_ENDPOINT}/history`, payload),
};
